import { ApiEndpoints, ActionHandler } from 'Utils';
import { Dispatch } from 'redux';
import { ToyTypes } from './Types'


export const getToy = () => (dispatch: Dispatch) => {
	const currentChildId = localStorage.getItem('currentChildId')
    const newUrl = ApiEndpoints.getToy + `/${currentChildId}`

    return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },

		(res) => {
			const { data } = res.data;
			dispatch({ type: ToyTypes.LOAD_TOY, payload: { data } });
		},
		(error) => {
			dispatch({ type: ToyTypes.ERROR_TOY, payload: { data: error } });
		},
	);
};

export const issueWithToy = (id:number) => (dispatch: Dispatch) => {
	const curretChildId = localStorage.getItem('currentChildId')
    const newUrl = `issue/${id}/${curretChildId}`
	const data = JSON.stringify({id})

    return ActionHandler(
		{ url: newUrl, method: 'POST', dispatch,data },

		(res) => {
			const { data } = res.data;
			// eslint-disable-next-line no-console
			console.log(data)
			dispatch({ type: ToyTypes.ISSUE, payload:{data} });
		},
		(error) => {
            //eslint-disable-next-line 
            console.log(error)
			dispatch({ type: ToyTypes.ERROR_TOY, payload: { errors: error } });
		},
	);
};

export const postQuestionarre = (que1:number,que2:number,ans1:number,ans2:number,ans3:number,ans4:number,toyId:string) => (dispatch: Dispatch) => {
	const childId = localStorage.getItem('currentChildId')
    const newUrl = ApiEndpoints.questionarre 
	const toyInstanceId = toyId;
	const data = JSON.stringify({que1,que2,ans1,ans2,ans3,ans4,toyInstanceId,childId})
	// eslint-disable-next-line no-console
	console.log(data)
    return ActionHandler(
		{ url: newUrl, method: 'POST', dispatch ,data},

		(res) => {
			const { data } = res.data;

			dispatch({ type: ToyTypes.POST_QUESTIONNAIRE });
		},
		(error) => {
            //eslint-disable-next-line 
            console.log(error)
			dispatch({ type: ToyTypes.ERROR_TOY, payload: { errors: error } });
		},
	);
};



export const getQuestions = () => (dispatch: Dispatch) => {

    return ActionHandler(
		{ url: ApiEndpoints.questions, method: 'GET', dispatch },

		(res) => {
			const { data } = res.data;

			dispatch({ type: ToyTypes.FETCH_QUESTIONNAIRE, payload: { data } });
		},
		(error) => {

			dispatch({ type: ToyTypes.ERROR_TOY, payload: { errors: error } });
		},
	);
};


export const generateNewToy = () => (dispatch: Dispatch) => {
	const childId = localStorage.getItem('currentChildId');
	const newUrl = ApiEndpoints.generateNewToy + `/${childId}`
    return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },

		(res) => {
			const { data } = res.data;

			dispatch({ type: ToyTypes.GENERATE_NEW_TOY });
		},
		(error) => {

			dispatch({ type: ToyTypes.ERROR_TOY, payload: { errors: error } });
		},
	);
};





